// removed by extract-text-webpack-plugin
module.exports = {"errorRed":"#DC001C","container":"container-16eIx","fields":"fields-1e5us","label":"label-2_9p7 label-Y5lvX","month":"month-2K2mn","required":"required-1uAdT","errorMessage":"errorMessage-1m-Cn errorMessage-ucFof"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/CCForm/_expiresField.css
// module id = 1241
// module chunks = 1